<template>
    <div class="row">
        <div class="col-lg-12 mb-3">
            <b-card :header="uLang('app.overview')" header-tag="h4" class="bg-default-card">
                
                <div>
                    <div class="pull-left">
                        <div class="p-2">
                            <span>{{ lang('app.rows_per_page_text') }} : </span>
                            <select class="rowsPerPageClass" name="rowsPerPage" id="rowsPerPage" v-model="rowsPerPage">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="45">45</option>
                                <option value="60">60</option>
                                <option value="90">90</option>
                            </select>
                        </div>
                    </div>
                    <div class="pull-right mb-3"
                        v-if="$can('create-relations')"
                    >
                        <router-link class="btn btn-brand" :to="{ name: 'admin.relations.create' }">{{ uLang('app.add_type', { type: lang('app.relation') }) }}</router-link>
                    </div>
                </div>

                <table-admin-relations
                    v-if="$can('view-relations')"
                    name="fancy-name"
                    :rows-per-page="rowsPerPage" 
                />
            </b-card>
        </div>
    </div>
</template>

<script>
    import TableAdminRelation from '~/components/tables/admin/relation/table'

    export default {
        name: 'index',

        data() {
            return {
                rowsPerPage: "90",
            }
        },

        components: {
            'table-admin-relations': TableAdminRelation,
        },
    }
</script>

<style lang="css" scoped>
.rowsPerPageClass {
    display: inline-block;
    width: 100px;
    padding: 6px;
}
</style>